import type React from "react"

import { useEffect, useState } from "react"
import { cn } from "../../lib/utils"

function Textarea({
  className,
  ...props
}: React.ComponentProps<"textarea"> & {
  showCounter?: boolean
}) {
  const { maxLength, onChange, showCounter, ...rest } = props
  const [currentLength, setCurrentLength] = useState(0)

  useEffect(() => {
    if (props.value !== undefined) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setCurrentLength(String(props.value).length)
    } else if (props.defaultValue !== undefined) {
      setCurrentLength(String(props.defaultValue).length)
    }
  }, [props.value, props.defaultValue])

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setCurrentLength(e.target.value.length)
    if (onChange) {
      onChange(e)
    }
  }

  const shouldShowCounter = maxLength && showCounter

  return (
    <div className="relative">
      <textarea
        className={cn(
          "flex min-h-20 w-full rounded-md border border-neutrals-200 bg-white px-3 py-2 text-base ring-offset-white placeholder:text-neutrals-700 focus-visible:ring-2 focus-visible:ring-neutrals-1000 focus-visible:ring-offset-2 focus-visible:outline-hidden disabled:cursor-not-allowed disabled:opacity-50 md:text-sm dark:border-neutrals-800 dark:bg-neutrals-1000 dark:ring-offset-neutrals-1000 dark:placeholder:text-neutrals-500 dark:focus-visible:ring-neutrals-400",
          shouldShowCounter && "pb-8",
          className
        )}
        data-slot="textarea"
        maxLength={maxLength}
        onChange={handleChange}
        {...rest}
      />
      {shouldShowCounter && (
        <div className="absolute right-3 bottom-2 bg-white px-1 text-sm text-neutrals-700 dark:bg-neutrals-1000 dark:text-neutrals-500">
          {currentLength}/{maxLength}
        </div>
      )}
    </div>
  )
}

export { Textarea }
